import { Layout, Menu } from 'antd';
import styled from 'styled-components';

const { Sider } = Layout;

export const StyledSider = styled(Sider)`
  background: ${props => props.theme.palette.background.secondary};
  height: 100vh;
  position: fixed;
  z-index: 2;
`;

export const Header = styled.div`
  padding: 25px;
`;

export const Logo = styled.img`
  width: 100%;
`;

export const StyledMenu = styled(Menu)`
  background: ${props => props.theme.palette.background.secondary};
`;

export const StyledMenuItemGroup = styled(Menu.ItemGroup)`
  margin-bottom: 40px;

  .ant-menu-item-group-title {
    color: ${props => props.theme.palette.text.primary};
    font-weight: bold;
    font-size: 16px;
  }
`;

export const StyledMenuItem = styled(Menu.Item)`
  &.ant-menu-item {
    margin-bottom: 0px !important;
    font-size: 16px;

    .anticon,
    a {
      color: ${props => props.theme.palette.text.primary};
    }
  }

  &.ant-menu-item-selected {
    background: ${props => props.theme.palette.primary.dark} !important;

    .anticon,
    a {
      color: ${props => props.theme.palette.text.light};
    }
  }
`;
